import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Table,
  Label,
  Alert,
} from "reactstrap";
import moment from "moment";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import { toastContainer } from "../../../utils/toast";
import Select from "react-select";

export default function LinkTriviaRewardPopup({
  // popupType,
  open,
  onClose,
  selectedItems,
  setSelectedItems,
  trivia,
  // afterLink,
  // triviaId,
}) {
  const title_text = "Reward";
  const [rewardOptions, setRewardOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  const getRewardOptions = () => {
    axios.get(url.getRewardOptionsForTrivvy(trivia._id)).then(({data}) => {
      const options = data.data.map((x) => ({
        label: x.rewardName,
        value: x._id,
        ...x,
      }));
      setRewardOptions(options);
    });
  };

  useEffect(() => {
    getRewardOptions();
  }, []);

  const linkReward = () => {
    const rewardId = selectedOption.value;
    const addRewardObject = {
      ...selectedOption,
    };

    console.log(addRewardObject)

    axios
      .post(url.linkRewardToTrivvy, {
        trivia,
        rewardId: addRewardObject._id,
      })
      .then((data) => {
        setSelectedOption(null)
        setSelectedItems([addRewardObject, ...selectedItems]);
        let options = [...rewardOptions];

        options = options.filter(x => x._id != addRewardObject._id)

        setRewardOptions(options)

      })
      .catch((err) => {
        toastContainer("Error while adding reward", "error");
      });
  };

  const usersTakenTrivvy = trivia && trivia.totalSubmissions > 0

  return (
    <div>
      <Modal isOpen={open} className="link-trivia-modal-component">
        <ModalHeader className="trivia_modal_header_bg" toggle={onClose}>
          Linked {title_text}
        </ModalHeader>
        <ModalBody className="px-4 py-3">
          <div className="my-4">
            {usersTakenTrivvy ? <Alert color="danger" className="my-2">Users has taken this Trivvy so you can no loger link rewards to this Trivvy now.</Alert>:""}
            <Label>Select reward</Label>
            <Select
              options={rewardOptions}
              value={selectedOption}
              onChange={(e) => {
                if (e && e.value) {
                  setSelectedOption(e);
                } else {
                  setSelectedOption(null);
                }
              }}
              placeholder="Select reward to link"
              disabled={usersTakenTrivvy}
            />

            <div className="text-right mt-3">
              <Button
                onClick={() => linkReward()}
                className="trivia-action-button-main"
                disabled={usersTakenTrivvy}
              >
                Add +
              </Button>
            </div>
          </div>
          <h5>Here is the linked {title_text}s</h5>

          <div className="my-2">
            <Table className="">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Reward</th>
                  <th>Description</th>
                  <th>Expire on</th>
                </tr>
              </thead>
              <tbody>
                {selectedItems.length
                  ? selectedItems.map((item) => {
                      return (
                        <tr key={item._id}>
                          <td>{item.rewardName}</td>
                          <td>{item.rewardText}</td>
                          <td>
                            {item.rewardTemplateId && item.rewardTemplateId.description
                              ? item.rewardTemplateId.description
                              : item.rewardDescription}
                          </td>
                          <td>
                            {moment(item.rewardDate).format("DD/MM/YYYY")}
                          </td>
                        </tr>
                      );
                    })
                  : "No items selected"}
              </tbody>
            </Table>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}
